/**
 * Computes the check digit for a resource ID using the ASCII procedure in
 * Section 6.2 of the BDEW identification rules (https://bdew-codes.de/Content/Files/Anwdh_2023-01-18-AWH-Identifikatoren-MaKo-Bildungsvorschrift_Version.1.0.pdf).
 * `numberStr` contains the one-character alphanumeric prefix and nine digits.
 */
function computeCheckDigitForResourceId(numberStr: string): number {
  let summed = 0;

  for (const [position, character] of Array.from(numberStr).entries()) {
    const multiplier = position % 2 === 0 ? 1 : 2;
    summed += multiplier * asciiToInt(character);
  }

  return Math.ceil(summed / 10) * 10 - summed;
}

function asciiToInt(value: string): number {
  if (/^[0-9]$/.test(value)) {
    return Number(value);
  }

  const codePoint = value.codePointAt(0);
  if (codePoint !== undefined && /^\p{L}$/u.test(value)) {
    return codePoint;
  }

  throw new Error("Expected a single alphanumeric character.");
}

export { computeCheckDigitForResourceId };
